/* ============
 * Mutations for the account module
 * ============
 *
 * The mutations that are available on the
 * account module.
 */


/* eslint-disable no-param-reassign */

import { CLEAR_DETAIL, GET_DETAIL_RICH_COUNT, GET_DETAIL_TX_COUNT } from './mutation-types';

export default {
  [GET_DETAIL_TX_COUNT](state, tx) {
    state['detail']['tx'] = tx;
  },
  [GET_DETAIL_RICH_COUNT](state, rich) {
    state['detail']['rich'] = rich;
  },
  [CLEAR_DETAIL](state) {
    state['detail'] = {
      tx: null,
      rich: null
    };
  }
};
